import { useEffect } from 'react';
import { Dispatch } from 'react';
import { getMinutesFromDateTime } from 'framework/utils';
import { AVAILABILITY_WS_EVENTS } from '../../socket/constants';
import { subscribeAvailabilitySocketEvent } from '../../socket/events';
import { normalizeSlotsPayload } from '../helpers/helpers';
import { getSlotEndMinutes } from '../helpers/time';
import { FocusTimeActionType, FocusTimeSlot, FocusTimeSlotsPayload } from '../types';

type UseFocusTimeEffectsParams = Readonly<{
  slots: FocusTimeSlot[];
  dispatch: Dispatch<{ type: FocusTimeActionType.SetCurrentMinutes; payload: number }>;
  setSlots: (nextSlots: FocusTimeSlot[]) => void;
}>;

export const useFocusTimeEffects = ({ slots, dispatch, setSlots }: UseFocusTimeEffectsParams) => {
  useEffect(() => {
    const intervalId = window.setInterval(() => {
      const nextCurrentMinutes = getMinutesFromDateTime();
      dispatch({ type: FocusTimeActionType.SetCurrentMinutes, payload: nextCurrentMinutes });
      const nextSlots = slots.filter(slot => getSlotEndMinutes(slot) > nextCurrentMinutes);
      if (nextSlots.length !== slots.length) {
        setSlots(nextSlots);
      }
    }, 60_000);

    return () => window.clearInterval(intervalId);
  }, [dispatch, setSlots, slots]);

  useEffect(() => {
    return subscribeAvailabilitySocketEvent<FocusTimeSlotsPayload>(
      AVAILABILITY_WS_EVENTS.FOCUS_SCHEDULES_UPDATED,
      payload => {
        setSlots(normalizeSlotsPayload(payload));
      },
    );
  }, [setSlots]);
};
